function ProjectForm() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Project.Overview visual. <br/>
   /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// ***********************************************************************<br />
    /// *** v1.0.6- 21.06.2017                                                *<br />
    /// * - fixed bug with empty telephone numbers                            *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.5 - 16.11.2016                                               *<br />
    /// * - fixed bug with checkboxes not correctly selected                  *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.4 - 27.07.2016                                               *<br />
    /// * - fixed bug with missing telephone number on import                 *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.3 - 27.07.2016                                               *<br />
    /// * - addedFiscalMonth                                                  *<br />
    /// * - made saving Information better                                    *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.2 - 25.07.2016                                               *<br />
    /// * - changed phonenumber to extra field                                *<br />
    /// * - added validation for phone number                                 *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// * - added specific info handling                                      *<br />
    /// *- added various form items and improved saving                       *<br />
    /// ***********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// ***********************************************************************<br />
    /// * - basic functionality                                               *<br />
    /// ***********************************************************************<br />
    /// </summary>
    // the following attributes got set in the corresponding vb Class 
    this.day = "";
    this.url = "";
}
ProjectForm.prototype = new window.vcTemplate();
ProjectForm.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        if (!me.projectInfo) {
            me.projectInfo = { customerid: me.customerid };
        }
        

        if (me.newProject === false) {
            if (!me.projectInfo.siteimage) {
                me.projectInfo.siteimage = -1;
            }
            me.fillFormItems();
        } else {
            me.visual.find("#txtLoggerID").val(-1);
            me.visual.find("#txtDeviceID").val(-1);
            me.visual.find("#ddlLoggerTimeKorr").val(0);
            me.visual.find("#txtSiteImage").val(-1);

        }


        me.initClickHandler();
        me.validation = new window.vcFormValidation(me.visual, me.visual.find("#divBtnSaveProject"));
       
        me.visual.find("#txtSiteImage").vcGallery({ customerid: me.customerid, mediaCategory: "CUSTLOGO", previewWidth: 50, previewHeight: 50, formItemWidth: 350, showDetails: true, onFileChanged: function () {
          me.validation.validate("#txtSiteImage", me.itemInfo["txtSiteImage"]); } });
        
        me.visual.find('.input').off("change keyup").on("change keyup", function (event) {
            me.validation.validate(event.currentTarget.id, me.itemInfo[event.currentTarget.id]);
        }).trigger("change");
        me.visual.find('.ddl.areacode').off("change keyup").on("change keyup", function (event) {
            //start at 3 to remove the 'ddl'
            me.validation.validate(event.currentTarget.id.substring(3), me.itemInfo[event.currentTarget.id.substring(3)]);
        }).trigger("change");
        me.visual.find('#divBtnSaveProject').button({
            "disabled": true
        });
        me.visual.find(".formFieldset").on("click", "#boxtxtSiteImage .fa",
            function () {
                me.validation.checkValidState();
            });

        return true;
    } catch (ex) {
        me.writeError("ProjectForm.init", ex);
        return false;
    }

};

ProjectForm.prototype.fillFormItems = function() {
    var me = this;
    var telSplit;
    try {
        if (me.error) {
            return false;
        }
        if (me.projectInfo.loggertimekorr < -12 || me.projectInfo.loggertimekorr > 12) me.projectInfo.loggertimekorr = 0;
    
        me.visual.find("#txtLoggerID").val(me.projectInfo.loggerid);
        me.visual.find("#txtDeviceID").val(me.projectInfo.deviceid);
        me.visual.find("#ddlManageTypeID option[value='" + me.projectInfo.loggerdatamanagetype + "']").prop("selected", true);
        me.visual.find("#ddlCurrency option[value='" + me.projectInfo.loggercurrencyid + "']").prop("selected", true);
        me.visual.find("#chbLoggerActive").prop("checked", JSON.parse(me.projectInfo.loggeractive.toLowerCase()));
        me.visual.find("#txtLoggerName").val(me.projectInfo.loggername);
        me.visual.find("#txtLoggerDescription").val(me.projectInfo.loggerdescription);
        me.visual.find("#ddlLoggerTimeKorr").val(me.projectInfo.loggertimekorr);
        me.visual.find("#txtDeviceActive").prop("checked", JSON.parse(me.projectInfo.deviceactive.toLowerCase()));
        me.visual.find("#txtDeviceName").val(me.projectInfo.devicename);
        me.visual.find("#txtDeviceDescription").val(me.projectInfo.devicedescription);
        me.visual.find("#txtAddress").val(me.projectInfo.deviceaddress);
        me.visual.find("#txtZipCode").val(me.projectInfo.areacode);
        me.visual.find("#txtCity").val(me.projectInfo.devicecity);
        me.visual.find("#txtCountry").val(me.projectInfo.country);
        me.visual.find("#ddlFiscalMonth").val(me.projectInfo.fiscalmonth);

        telSplit = me.projectInfo.telnr.split("-");
        if (telSplit[0].length >= 1) {
            me.visual.find("#ddltxtPhone").val(telSplit[0]);
        } else {
            me.visual.find("#ddltxtPhone option[value='0043']").attr("selected", "selected");
        }

        //me.visual.find("#ddltxtPhone").val(telSplit[0]);
        me.visual.find("#txtPhone").val(telSplit[1]);
        me.visual.find("#txtFax").val(me.projectInfo.faxnr);
        me.visual.find("#txtEmail").val(me.projectInfo.email);
        me.visual.find("#txtURL").val(me.projectInfo.url);
        me.visual.find("#txtSiteImage").val(me.projectInfo.siteimage);
    } catch (ex) {
        me.writeError("ProjectForm.fillFormItems", ex);
        return false;
    }
    return true;
};
ProjectForm.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// by calling the webservice and calling the overview list again
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        var visual = new window.vcVisual();
        visual.addVisualContentByName("divProjectOverview", "WIDGET_PROJECT_OVERVIEW_LIST", "", '27.11.2015', 1000, 1800, "", "", 1);

    } catch (ex) {
        me.writeError("ProjectForm.btnBack", ex);
        return false;
    }
    return true;
};

ProjectForm.prototype.btnSave = function () {
    /// <summary>
    /// Handles the click of the save button for the ProjectForm <br/>
    /// by retrieving all values and sending them to the webservice
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
        if (me.visual.find("#divBtnSaveProject").button("option", "disabled")) { return false }
        me.visual.find("#divBtnSaveProject i.fa-check").hide();

        if(!me.projectInfo) me.projectInfo = new Object();
        me.projectInfo.deviceactive = me.projectInfo.loggeractive = me.visual.find("#chbLoggerActive").prop("checked");
        me.projectInfo.loggername = me.visual.find("#txtLoggerName").val();
        me.projectInfo.loggerdescription = me.visual.find("#txtLoggerDescription").val();
        me.projectInfo.loggertimekorr = parseInt(me.visual.find("#ddlLoggerTimeKorr").val());
        me.projectInfo.loggerdatamanagetype = me.visual.find("#ddlManageTypeID option:selected").val();
        me.projectInfo.loggercurrencyid = me.visual.find("#ddlCurrency option:selected").val();
        me.projectInfo.devicename = me.visual.find("#txtDeviceName").val();
        me.projectInfo.devicedescription = me.visual.find("#txtDeviceDescription").val();
        me.projectInfo.deviceaddress = me.visual.find("#txtAddress").val();
        me.projectInfo.areacode = me.visual.find("#txtZipCode").val();
        me.projectInfo.devicecity=  me.visual.find("#txtCity").val();
        me.projectInfo.country = parseInt(me.visual.find("#txtCountry").val());
        if (me.visual.find("#ddltxtPhone").val() && me.visual.find("#txtPhone").val().length > 0) {
            me.projectInfo.telnr = me.visual.find("#ddltxtPhone").val().concat("-", me.visual.find("#txtPhone").val());
        } else {
            me.projectInfo.telnr = null;
        }
        me.projectInfo.faxnr= me.visual.find("#txtFax").val();
        me.projectInfo.email= me.visual.find("#txtEmail").val();
        me.projectInfo.url = me.visual.find("#txtURL").val();
        me.projectInfo.fiscalmonth = me.visual.find("#ddlFiscalMonth").val();
        me.projectInfo.siteimage = parseInt(me.visual.find("#txtSiteImage").val());
        me.projectInfo.newProject = me.newProject;
        window.VisualCoreService.updateData(me.vcvid, me.vcgid, window.getCurrentTimestamp(), 0, 0, "", "", 2, 2, JSON.stringify(me.projectInfo), function(res) {
            //me.showInfo(res, "", false);
            var resobj = JSON.parse(res);
            if (resobj.LoggerID !== -1) {
                me.visual.find("#divBtnSaveProject").button("disable");
                me.visual.find("#divBtnSaveProject i.fa-check").show();
                me.showInfo(me.resources.saveSucess,false);
                window._VCMQ.produce(me.visual, me.vcgid, 'PROJECT_SAVE', { loggerid: resobj.LoggerID, deviceid: resobj.DeviceID });
            } else {
                me.showInfo(me.resources.err_saveData, true);
            }
        });
        return true;
    } catch (ex) {
        me.writeError("ProjectForm.btnSave", ex); return false;
    }
};
ProjectForm.prototype.doEvent = function () {
    ////CURRENTLY DOES NOTHING JUST HERE TO AVOID ERRORS 
};

ProjectForm.prototype.initClickHandler = function () {
    /// <summary>
    /// Initializes all clickhandlers once 
    /// </summary>
    var me = this;
    var bRet = true;
    try {
        if (me.error) {
            bRet = false;
        } else {
            me.visual.find('#divBtnBackToOverview').button().off("click").on("click", function () { me.btnBack(); });
            me.visual.find('#divBtnImportCustomerData').button().off("click").on("click", function () { me.importCustomerData(); });

            me.visual.find('#divBtnSaveProject').button({
                "disabled":true
        }).off("click").on("click", function() {
                me.btnSave();
            }).css({ margin: 0 });
        }
    } catch (ex) {
        me.writeError("ProjectForm.initClickHandler", ex); bRet = false;
    }
    return bRet;
};

ProjectForm.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find("#divProjectForm, fieldset").hide();
        }
        return true;
    } catch (ex) {
        me.writeError("ProjectForm.specificInfoHandling", ex);
        return false;
    }
};
ProjectForm.prototype.importCustomerData = function() {
    /// <summary>
    /// this function calls the webservice to get the customer data and sets the fields accordingly
    /// </summary>
    var me = this;
    try {

        if (me.error) { return false; }

        if (me.newProject) {
            me.projectInfo = { "customerid": me.customerid };
        }

            me.projectInfo.customerid = me.customerid;
            var dialog = $("<div>");
        dialog.html(me.resources.overrideAddress);
            dialog.dialog({
                dialogClass: "saveDialog",
                modal: true,
                buttons: 
                    [
                        {
                            text: me.resources.yes,
                            click: function() {
                                me.importProject();
                                $(this).dialog("close");

                            }
                        },
                        {
                            text: me.resources.no,
                            click: function() {
                                $(this).dialog("close");
                            }                              
                        }
                    ]
                
            }).dialog("open");
        


        return false;
    } catch (ex) {
        me.writeError("ProjectForm.js.importCustomerData", ex);
        return false;
    }
};
ProjectForm.prototype.importProject = function () {
    ///<summary>
    ///Imports the Customer Address and <br/>
    ///effectively overrides any old address if present
    ///</summary>
    var me = this;
    try {

        window.VisualCoreService.getData(me.vcvid,me.vcgid,window.getCurrentTimestamp(),0,0,'','',2,2,JSON.stringify(me.projectInfo),
            function(result) {
                var resObj = JSON.parse(result);
                me.projectInfo = resObj;

                me.visual.find("#txtLoggerName").val(resObj.LoggerName);
                me.visual.find("#ddlLoggerTimeKorr").val(resObj.LoggerTimekorr || 0);
                me.visual.find("#txtDeviceName").val(resObj.DeviceName);
                me.visual.find("#txtAddress").val(resObj.DeviceAddress);
                me.visual.find("#txtZipCode").val(resObj.areacode);
                me.visual.find("#txtCity").val(resObj.devicecity);
                me.visual.find("#txtCountry").val(resObj.Country);
                var telSplit = resObj.telnr.split("-");
                if (telSplit[0].length >= 1) {
                    me.visual.find("#ddltxtPhone").val(telSplit[0]);
                } else {
                    me.visual.find("#ddltxtPhone option:first").selected = true;
                }
                me.visual.find("#txtPhone").val(telSplit[1]);
                me.visual.find("#txtFax").val(resObj.faxnr);
                me.visual.find("#txtEmail").val(resObj.email);
                me.visual.find("#txtURL").val(resObj.url);
                me.visual.find("#txtSiteImage").val(resObj.siteimage);
                me.visual.find("#txtSiteImage").vcGallery({
                    customerid: me.customerid,
                    mediaCategory: "CUSTLOGO",
                    previewWidth: 50,
                    previewHeight: 50,
                    formItemWidth: 350,
                    showDetails: true,
                    onFileChanged: function() { me.validation.validate(); }
                });
                me.visual.find('.input').trigger("change");
            });
    } catch (ex) {
        me.writeError("ProjectForm.js.Import", ex);

    }
};
